export default __webpack_public_path__ + "static/media/aston-martin.635f64c8.svg";